// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ef6a72a5d694f0b6853e47f467f173faa53618d6.chunk.js";
};